import React, { useState } from 'react';
import axios from 'axios';
import URL from '../constants/ServerUrl';
import { useSearchParams , useNavigate } from 'react-router-dom';

const AddUser = () => {
    const [formData, setFormData] = useState({
        username: '',
        userId: '',
        password: '',
        mobileNo: '',
        contactPerson: '',
        address: '',
        allowAddFarmer: 'Not Allow',
        allowLedger: 'Not Allow',
        allowPayment: 'Not Allow',
        allowRateChart: 'Not Allow',
        allowDues: 'Not Allow',
    });
    const [errorMessage, setErrorMessage] = useState('');
    const token = localStorage.getItem('dairy-token');
    const navigate=useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${URL}user/signup`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            navigate(-1);
        } catch (error) {
            setErrorMessage(error.response?.data?.error || 'An error occurred');
        }
    };

    return (
        <div className="container mx-auto p-4">

<h1 className="text-2xl font-bold text-center text-blue-600 mb-6">Add New User</h1>
            <form
                onSubmit={handleSubmit}
                className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
            >
                <div className="mb-4">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="username"
                    >
                        Username
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="username"
                        type="text"
                        placeholder="Username"
                        name="username"
                        onChange={handleChange}
                        value={formData.username}
                    />
                </div>
                <div className="mb-4">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="userId"
                    >
                        User ID
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="userId"
                        type="text"
                        placeholder="User ID"
                        name="userId"
                        onChange={handleChange}
                        value={formData.userId}
                    />
                </div>
                <div className="mb-6">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="password"
                    >
                        Password
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                        id="password"
                        type="password"
                        placeholder="******************"
                        name="password"
                        onChange={handleChange}
                        value={formData.password}
                    />
                </div>
                <div className="mb-4">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="mobileNo"
                    >
                        Mobile Number
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="mobileNo"
                        type="text"
                        placeholder="Mobile Number"
                        name="mobileNo"
                        onChange={handleChange}
                        value={formData.mobileNo}
                    />
                </div>
                <div className="mb-4">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="contactPerson"
                    >
                        Contact Person
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="contactPerson"
                        type="text"
                        placeholder="Contact Person"
                        name="contactPerson"
                        onChange={handleChange}
                        value={formData.contactPerson}
                    />
                </div>
                <div className="mb-4">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="address"
                    >
                        Address
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="address"
                        type="text"
                        placeholder="Address"
                        name="address"
                        onChange={handleChange}
                        value={formData.address}
                    />
                </div>
                <div className="mb-4">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="allowAddFarmer"
                    >
                        Allow Add Farmer
                    </label>
                    <select
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="allowAddFarmer"
                        name="allowAddFarmer"
                        onChange={handleChange}
                        value={formData.allowAddFarmer}
                    >
                        <option value="Allow">Allow</option>
                        <option value="Not Allow">Not Allow</option>
                    </select>
                </div>
                <div className="mb-4">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="allowAddFarmer"
                    >
                        Allow Ledger
                    </label>
                    <select
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="allowLedger"
                        name="allowLedger"
                        onChange={handleChange}
                        value={formData.allowLedger}
                    >
                        <option value="Allow">Allow</option>
                        <option value="Not Allow">Not Allow</option>
                    </select>
                </div>

                <div className="mb-4">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="allowAddFarmer"
                    >
                        Allow Payment
                    </label>
                    <select
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="allowPayment"
                        name="allowPayment"
                        onChange={handleChange}
                        value={formData.allowPayment}
                    >
                        <option value="Allow">Allow</option>
                        <option value="Not Allow">Not Allow</option>
                    </select>
                </div>

                <div className="mb-4">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="allowAddFarmer"
                    >
                        Allow RateChart
                    </label>
                    <select
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="allowRateChart"
                        name="allowRateChart"
                        onChange={handleChange}
                        value={formData.allowRateChart}
                    >
                        <option value="Allow">Allow</option>
                        <option value="Not Allow">Not Allow</option>
                    </select>
                </div>

                <div className="mb-4">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="allowAddFarmer"
                    >
                        Allow Dues
                    </label>
                    <select
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="allowDues"
                        name="allowDues"
                        onChange={handleChange}
                        value={formData.allowDues}
                    >
                        <option value="Allow">Allow</option>
                        <option value="Not Allow">Not Allow</option>
                    </select>
                </div>
              

                <div className="flex items-center justify-between">
                    <button
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="submit"
                    >
                        Register
                    </button>
                </div>
                {errorMessage && (
                    <p className="text-red-500 text-xs italic">{errorMessage}</p>
                )}
            </form>
        </div>
    );
};

export default AddUser;
